export const THUMBNAIL_DEFAULT_WIDTH = 134;
export const THUMBNAIL_DEFAULT_HEIGHT = 134;

export const BROCHURE_AND_DOCS_QUERY_KEY = ['community', 'brochures', 'documents'];

export const brochureAndDocsQueryKey = (id: number) => [...BROCHURE_AND_DOCS_QUERY_KEY, id];
